module.exports = __webpack_public_path__ + "img/CL.04aea4bd.png";